// The full updated code with subject-professor pairing UI and logic

import React, { useEffect, useState } from "react";
import { FaUpload } from "react-icons/fa";
import Customform from "../../ui/custom-form";
import CustomInput from "../../ui/custom-input";
import CustomButton from "../../ui/custom-button";
import {
  AddStudentApi,
  CourseListApi,
  GetBranch,
  getStudentData,
  ProfessorListApi,
  SemesterListApiByCourse,
  SubjectListApiBySemester,
  updateStudentdata,
} from "../../api/api";
import { PulseLoader } from "react-spinners";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { or } from "ajv/dist/compile/codegen";

const AddStudentForm = () => {
  const [activeTab, setActiveTab] = useState("basic");
  const [loading, setLoading] = useState(false);
  const [course, setCourse] = useState([]);
  const [branch, setBranch] = useState([]);
  console.log("branch", branch);
  const [semester, setSemester] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [professor, setProfessor] = useState([]);
  const [subjectProfessors, setSubjectProfessors] = useState([]); // New state
  const [previewUrl, setPreviewUrl] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const { user_id, organization_id } = useSelector(
    (state) => state?.authUser?.data?.data
  );
  //console.log("id", id);
  const [formdata, setFormData] = useState({
    name: "",
    DOB: "",
    gender: "Female",
    email: "",
    mobile_number: "",
    alternate_number: "",
    permanent_address: "",
    current_address: "",
    images: null,
    enrollment_no: "",
    course_id: "",
    // semester: "",
    branch_id: "",
    admission_year: "",
    year_semester: "",
    roll_no: "",
    subjects: [],
  });

  useEffect(() => {
    if (formdata.images) {
      const objectUrl = URL.createObjectURL(formdata.images);
      setPreviewUrl(objectUrl);
      return () => URL.revokeObjectURL(objectUrl);
    } else {
      setPreviewUrl(null);
    }
  }, [formdata.images]);

  useEffect(() => {
    const fetchData = async () => {
      const [courseRes, branchRes] = await Promise.all([
        CourseListApi(debouncedSearch, user_id, organization_id),
        // ProfessorListApi(),
        GetBranch(user_id, organization_id),
      ]);
      console.log("branchRes", branchRes);
      if (courseRes?.data?.status) setCourse(courseRes.data.data);
      // if (professorRes?.data?.status) setProfessor(professorRes.data.data);

      if (branchRes?.data) setBranch(branchRes.data.data);
    };
    fetchData();

    if (id) {
      const fetchDetail = async () => {
        const data = await getStudentData(id);

        if (data?.data?.status === true) {
          //console.log("datadeatsi", data?.data?.data);
        }
        if (data?.data?.status === true) {
          const d = data.data.data;
          setFormData({
            name: d.name || "",
            DOB: d.DOB || "",
            gender: d.gender || "Female",
            email: d.email || "",
            mobile_number: d.mobile_number || "",
            alternate_number: d.alternate_number || "",
            permanent_address: d.permanent_address || "",
            current_address: d.current_address || "",
            enrollment_no: d.enrollment_no || "",
            course_id: d.course_id || "",
            // semester: d.semester_id || "",
            branch_id: d.branch_id || "",
            admission_year: d.admission_year || "",
            year_semester: d.year_semester || "",
            roll_no: d.roll_no || "",
            subjects: d.subject_data || [],
            images: null,
            existingImage: d.images?.[0] || "",
            student_id: id,
          });

          // if (d.course_id) {
          //   const semRes = await SemesterListApiByCourse(d.course_id);
          //   if (semRes?.data?.status) setSemester(semRes.data.semesters);
          // }
          if (d.semester_id) {
            const subjRes = await SubjectListApiBySemester(d.semester_id);
            if (subjRes?.data?.status) {
              setSubjects(subjRes.data.subjects);
            }
          }

          if (d.images?.length) {
            setPreviewUrl(
              `${process.env.REACT_APP_BACKEND_URL}/${d.images[0]}`
            );
          }
        }
      };
      fetchDetail();
    }
  }, []);

  const handleChange = async (e) => {
    const { name, value, type, files } = e.target;

    if (type === "file") {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
      return;
    }

    if (name === "course_id") {
      setFormData((prev) => ({
        ...prev,
        course_id: value,
        // semester: "",
        subjects: [],
      }));
      // try {
      //   const res = await SemesterListApiByCourse(value);
      //   if (res?.data?.status) {
      //     setSemester(res.data.semesters);
      //     setSubjects([]);

      //   }
      // } catch (err) {
      //   console.error("Failed to fetch semesters", err);
      // }
      // return;
    }

    // if (name === "semester") {
    //   try {
    //     const res = await SubjectListApiBySemester(value);
    //     if (res?.data?.status) {
    //       setSubjects(res.data.subjects);
    //       const mappedSubjects = res.data.subjects.map((s) => ({
    //         subject_id: s._id,
    //         professor_id: "",
    //       }));
    //       setFormData((prev) => ({
    //         ...prev,
    //         semester: value,
    //         subjects: mappedSubjects,
    //       }));
    //     }
    //   } catch (err) {
    //     console.error("Failed to fetch subjects", err);
    //   }
    //   return;
    // }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleProfessorSelect = (subject_id, professor_id) => {
    setFormData((prev) => ({
      ...prev,
      subjects: prev.subjects.map((s) =>
        s.subject_id === subject_id ? { ...s, professor_id } : s
      ),
    }));
  };

  const handleNext = async (e) => {
    e.preventDefault();

    if (activeTab === "basic") {
      setActiveTab("academic");
      return;
    }

    const payload = new FormData();

    Object.entries(formdata).forEach(([key, value]) => {
      if (key !== "subjects" && key !== "existingImage" && key !== "images") {
        payload.append(key, value);
      }
    });

    // formdata.subjects.forEach((s, idx) => {
    //   payload.append(`subject_id[${idx}]`, s.subject_id);
    //   payload.append(`professor_id[${idx}]`, s.professor_id);
    // });
    if (formdata.student_id) {
      payload.append("student_id", formdata.student_id);
    }

    if (formdata.images) {
      payload.append("images", formdata.images);
    } else if (formdata.existingImage) {
      try {
        const imageResponse = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/${formdata.existingImage}`
        );
        const blob = await imageResponse.blob();
        //console.log("blob", blob);
        const file = new File([blob], "existing-image.jpg", {
          type: blob.type,
        });
        //console.log("file", file);
        payload.append("images", file);
      } catch (err) {
        console.error("Failed to fetch existing image as blob", err);
      }
    }
    payload.append("user_id", user_id);
    payload.append("organization_id", organization_id);

    setLoading(true);
    try {
      const res = id
        ? await updateStudentdata(payload)
        : await AddStudentApi(payload);

      if (res?.data?.status) navigate("/user-configure");
    } catch (err) {
      console.error("Submission failed", err);
    } finally {
      setLoading(false);
    }
  };

  const renderBasicInfo = () => (
    <div className="row formBox">
      <div className="col-md-4 mb-3">
        <label className="form-label">Name</label>
        <CustomInput
          name="name"
          value={formdata.name}
          onChange={handleChange}
        />
      </div>
      <div className="col-md-4 mb-3">
        <label className="form-label">Date of Birth</label>
        <CustomInput
          type="date"
          name="DOB"
          value={formdata.DOB}
          onChange={handleChange}
        />
      </div>
      <div className="col-md-4 mb-3">
        <label className="form-label d-block">Gender</label>
        <div className="d-flex gap-3">
          {["Male", "Female", "Other"].map((g) => (
            <label
              key={g}
              className={`custom-radio-btn d-flex align-items-center gap-2 ${
                formdata.gender === g ? "selected" : ""
              }`}
            >
              <input
                type="radio"
                name="gender"
                value={g}
                checked={formdata.gender === g}
                onChange={handleChange}
                className="radio-input"
              />
              <span className="label-text">{g}</span>
            </label>
          ))}
        </div>
      </div>
      <div className="col-md-4 mb-3">
        <label className="form-label">Email Address</label>
        <CustomInput
          name="email"
          value={formdata.email}
          onChange={handleChange}
        />
      </div>
      <div className="col-md-4 mb-3">
        <label className="form-label">Mobile Number</label>
        <CustomInput
          name="mobile_number"
          value={formdata.mobile_number}
          onChange={handleChange}
        />
      </div>
      <div className="col-md-4 mb-3">
        <label className="form-label">Alternate Phone</label>
        <CustomInput
          name="alternate_number"
          value={formdata.alternate_number}
          onChange={handleChange}
        />
      </div>
      <div className="col-md-4 mb-3">
        <label className="form-label">Permanent Address</label>
        <textarea
          className="form-control"
          name="permanent_address"
          value={formdata.permanent_address}
          onChange={handleChange}
          rows="4"
        />
      </div>
      <div className="col-md-4 mb-3">
        <label className="form-label">Current Address</label>
        <textarea
          className="form-control"
          name="current_address"
          value={formdata.current_address}
          onChange={handleChange}
          rows="4"
        />
      </div>
      <div className="col-md-4 mb-3">
        <label className="form-label">Upload Image</label>
        <div
          className="border rounded-4 p-3 text-center"
          style={{ background: "#eef4ff" }}
        >
          <label htmlFor="image-upload" style={{ cursor: "pointer" }}>
            <FaUpload size={20} />
            <div>Click to Upload</div>
            <small>Formats: jpg, jpeg, png, webp, gif</small>
          </label>
          <input
            type="file"
            id="image-upload"
            name="images"
            accept="image/*"
            onChange={handleChange}
            style={{ display: "none" }}
          />
          {previewUrl && (
            <div className="mt-2">
              <strong>Selected:</strong> {formdata.images?.name}
              <div className="mt-2">
                <img
                  src={previewUrl}
                  alt="Preview"
                  style={{ maxWidth: "100%", height: "auto" }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  const renderSubjectProfessorBlock = () => (
    <div className="col-12 mb-3">
      <label className="form-label">Subjects & Professors</label>
      {formdata.subjects.length === 0 ? (
        <p className="text-muted">Select course and semester first.</p>
      ) : (
        formdata.subjects.map((subj, idx) => {
          const subjectInfo = subjects.find((s) => s._id === subj.subject_id);
          return (
            <div key={subj.subject_id} className="row mb-2 align-items-center">
              <div className="col-md-6">
                <strong>{subjectInfo?.subject_name || "Subject"}</strong>
              </div>
              <div className="col-md-6">
                <select
                  className="form-select"
                  value={subj.professor_id}
                  onChange={(e) =>
                    handleProfessorSelect(subj.subject_id, e.target.value)
                  }
                >
                  <option value="">Select Professor</option>
                  {professor.map((prof) => (
                    <option key={prof._id} value={prof._id}>
                      {prof.professor_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          );
        })
      )}
    </div>
  );

  const renderAcademicInfo = () => (
    <div className="row formBox">
      <div className="col-md-4 mb-3">
        <label className="form-label">Enrollment Number / Student ID</label>
        <CustomInput
          name="enrollment_no"
          value={formdata.enrollment_no}
          onChange={handleChange}
          placeholder="SHARDA20587"
        />
      </div>
      <div className="col-md-4 mb-3">
        <label className="form-label">Admission Year</label>
        <CustomInput
          name="admission_year"
          value={formdata.admission_year}
          onChange={handleChange}
          placeholder="2024-2025"
        />
      </div>
      <div className="col-md-4 mb-3">
        <label className="form-label">Roll Number</label>
        <CustomInput
          name="roll_no"
          value={formdata.roll_no}
          onChange={handleChange}
        />
      </div>

      <div className="col-md-4 mb-3">
        <label className="form-label">Branch</label>
        <select
          className="form-select"
          name="branch_id"
          value={formdata.branch_id}
          onChange={handleChange}
        >
          <option value="">Select Branch</option>
          {branch.map((b) => (
            <option key={b._id} value={b._id}>
              {b.branch_name}
            </option>
          ))}
        </select>
      </div>

      <div className="col-md-4 mb-3">
        <label className="form-label">Year & Semester</label>
        <CustomInput
          name="year_semester"
          value={formdata.year_semester}
          onChange={handleChange}
        />
      </div>

      <div className="col-md-4 mb-3">
        <label className="form-label">Course</label>
        <select
          className="form-select"
          name="course_id"
          value={formdata.course_id}
          onChange={handleChange}
        >
          <option value="">Select</option>
          {course.map((c) => (
            <option key={c._id} value={c._id}>
              {c.course_name}
            </option>
          ))}
        </select>
      </div>
      {/* {formdata.course_id && (
        <div className="col-md-4 mb-3">
          <label className="form-label">Semester</label>
          <select
            className="form-select"
            name="semester"
            value={formdata.semester}
            onChange={handleChange}
          >
            <option value="">Select</option>
            {semester.map((s) => (
              <option key={s._id} value={s._id}>
                {s.semester_name}
              </option>
            ))}
          </select>
        </div>
      )} */}
      {/* {formdata.semester && renderSubjectProfessorBlock()} */}
      {/* ... other academic fields ... */}
    </div>
  );

  return (
    <aside className="mainSection">
      <div className="p-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3>Add Students</h3>
          <button className="mainBlue2 py-2 px-4">Upload CSV</button>
        </div>

        <div className="customeTabBox border rounded bg-white">
          <ul className="tabBox d-flex p-0 mb-4">
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "basic" ? "active" : ""}`}
                onClick={() => setActiveTab("basic")}
              >
                Basic Information
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${
                  activeTab === "academic" ? "active" : ""
                }`}
                onClick={() => setActiveTab("academic")}
              >
                Academic Details
              </button>
            </li>
          </ul>

          <div className="p-4">
            <Customform onSubmit={handleNext}>
              <div key={activeTab}>
                {activeTab === "basic"
                  ? renderBasicInfo()
                  : renderAcademicInfo()}
              </div>
              <div className="buttonGroup justify-content-end mt-4">
                <button
                  className="cancelBtn py-2 px-4"
                  onClick={() => {
                    if (activeTab === "academic") {
                      setActiveTab("basic");
                    } else {
                      navigate(-1);
                    }
                  }}
                >
                  Back
                </button>

                <button
                  type="submit"
                  className="nextBtn py-2 px-4"
                  disabled={loading}
                >
                  {loading ? (
                    <PulseLoader color="#fff" size={8} />
                  ) : activeTab === "basic" ? (
                    "Next"
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </Customform>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default AddStudentForm;
